<button class="td-wb-confirm-button"
        tdWbButton
        tdWbButtonType="primary"
        [tdWbModalClose]="value()">
  @if (label.innerText.trim() === '') {
    <span translate="tdWb.confirm.OK"></span>
  }
  <span #label>
    <ng-content />
  </span>
</button>
